<template>
  <div class="page_taxInfoList">
    <!-- 顶部查询区 -->
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <el-form :inline="true" :model="listQuery" class="re_down_form declareForm" label-width="88px">
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.Name" size="small" clearable placeholder="请输入姓名" style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" size="small" label-width="127px">
              <el-input v-model="listQuery.CardId" size="small" clearable placeholder="请输入身份证号码" style="width:180px"></el-input>
            </el-form-item>
            <el-tooltip class="scr_icon cp" effect="dark" content="高级检索项" placement="top-start" style="margin-left: 10px;line-height: 34px;">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>

    <!-- 高级筛选 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form declareForm" label-width="88px">
          <el-form-item label="手机号" size="small">
            <el-input v-model="listQuery.PhoneNum" size="small" clearable placeholder="请输入手机号" style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="发薪主体" size="small" label-width="127px">
            <el-select v-model="listQuery.PayrollCompany" filterable clearable placeholder="请选择发薪主体" size="small" style="width:180px">
              <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetQuery()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="main-con">
      <!-- 操作按钮 -->
      <div class="ftabBtn flex" style="background:#fff; padding: 10px 15px; border-top: 1px solid #ebeef5;">
        <el-button type="primary" size="small" @click="handleAdd" style="margin-left:10px">新增</el-button>
        <el-button type="success" size="small" @click="importExcel" v-preventReClick style="margin-left:10px">导入</el-button>
        <el-button type="warning" size="small" @click="exporList" v-preventReClick style="margin-left:10px">导出</el-button>
      </div>
      <el-table :data="tableData" border v-loading="loading" style="width:100%; background:#fff">
        <el-table-column label="姓名" prop="name" min-width="100" show-overflow-tooltip  align="center" ></el-table-column>
        <el-table-column label="身份证号码" prop="cardId" min-width="180" show-overflow-tooltip  align="center" ></el-table-column>
        <el-table-column label="手机号" prop="phoneNum" width="130" show-overflow-tooltip  align="center" ></el-table-column>
        <el-table-column label="入职时间" prop="employmentDay" width="110" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="发薪主体（报税主体）" prop="payrollCompany" min-width="180" show-overflow-tooltip  align="center" ></el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-popconfirm title="请确认是否删除？" @confirm="handleDelete(scope.row)" style="margin:0 10px">
              <el-button type="text" size="small" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination v-if="pageTotal > 0" background layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" :current-page.sync="listQuery.PageModel.Page" :page-size.sync="listQuery.PageModel.Rows" :page-sizes="[10, 20, 50, 100]" @size-change="handleSizeChange" @current-change="getList()" style="background:#fff; padding:15px; text-align:right"></el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" :append-to-body="true">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
        <el-form-item label="姓名" prop="Name">
          <el-input v-model="ruleForm.Name" placeholder="请输入姓名" size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="CardId">
          <el-input v-model="ruleForm.CardId" placeholder="请输入身份证号码" size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="PhoneNum">
          <el-input v-model="ruleForm.PhoneNum" placeholder="请输入手机号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="入职时间" prop="EmploymentDay">
          <el-date-picker v-model="ruleForm.EmploymentDay" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="请选择入职时间" style="width:100%" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="发薪主体" prop="PayrollCompany" size="small">
          <el-select v-model="ruleForm.PayrollCompany" filterable clearable placeholder="请选择发薪主体" size="small" style="width:100%">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog title="税务端信息采集导入" :visible.sync="showImport" width="500px" :close-on-click-modal="false" :append-to-body="true">
      <el-form label-width="100px">
        <el-form-item label="下载模板">
          <el-link type="primary" @click="downloadTemp">点击下载导入模板</el-link>
        </el-form-item>
        <el-form-item label="上传Excel">
          <el-upload action="#" :auto-upload="false" :on-change="handleUpload" :on-remove="handleRemove" :limit="1" accept=".xlsx,.xls">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              仅支持 .xlsx / .xls 文件；请先下载模板填写后再上传。<br />
              发薪主体须存在于法务主体数据源中。
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" @click="confirmImport">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import Cookies from "js-cookie";
  import xz from "../../common";

  export default {
    name: "taxInfoList",
    components: {},
    data() {
      return {
        showDropScreen: -1,
        listQuery: {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "Id",
              order: 1,
            }, ],
          },
          Name: "",
          CardId: "",
          PhoneNum: "",
          PayrollCompany: "",
        },
        tableData: [],
        pageTotal: 0,
        loading: false,
        legList: [],
        dialogVisible: false,
        dialogTitle: "新增",
        isBtnLoading: false,
        ruleForm: {
          Id: "",
          Name: "",
          CardId: "",
          PhoneNum: "",
          EmploymentDay: "",
          PayrollCompany: "",
        },
        rules: {
          Name: [{
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }],
          CardId: [{
            required: true,
            message: "请输入身份证号码",
            trigger: "blur"
          }],
          PayrollCompany: [{
            required: true,
            message: "请选择发薪主体",
            trigger: "change"
          }],
        },
        showImport: false,
        importUrl: "",
        headPath: this.$store.state.EMP.tablePath,
      };
    },
    created() {
      this.getLegalList();
      this.getList();
    },
    methods: {
      // 获取法务主体（发薪主体）下拉
      getLegalList() {
        let that = this;
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: "",
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000,
        };
        xz.ArdCurStat(d, "GetUserLegalList").then((res) => {
          if (res.status == "ok") {
            that.legList = res.data.date;
          } else {
            that.legList = [];
          }
        });
      },
      // C118 分页查询
      getList() {
        let that = this;
        that.loading = true;
        let data = Object.assign({}, that.listQuery);
        xz.ArdCurStat(data, "GetTaxInforCollectionPageList").then((res) => {
          that.loading = false;
          if (res.status == "ok") {
            that.tableData = (res.data && res.data.data) || [];
            that.pageTotal = (res.data && res.data.pageModel && res.data.pageModel.totalCount) || 0;
          } else {
            that.$message.error(res.msg || "查询失败");
          }
        });
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      resetQuery() {
        this.listQuery = {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "Id",
              order: 1,
            }, ],
          },
          Name: "",
          CardId: "",
          PhoneNum: "",
          PayrollCompany: "",
        };
        this.getList();
      },
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 新增
      handleAdd() {
        this.dialogTitle = "新增";
        this.ruleForm = {
          Id: "",
          Name: "",
          CardId: "",
          PhoneNum: "",
          EmploymentDay: "",
          PayrollCompany: "",
        };
        this.dialogVisible = true;
      },
      // 编辑
      handleEdit(row) {
        this.dialogTitle = "编辑";
        this.ruleForm = {
          Id: row.id,
          Name: row.name,
          CardId: row.cardId,
          PhoneNum: row.phoneNum,
          EmploymentDay: row.employmentDay,
          PayrollCompany: row.payrollCompany,
        };
        this.dialogVisible = true;
      },
      // C119 删除
      handleDelete(row) {
        let data = {
          Id: row.id,
          isDelete: "1",
        };
        xz.ArdCurStat(data, "AddDelUpTaxInforCollection").then((res) => {
          if (res.status == "ok") {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        });
      },
      // C119 新增/编辑提交
      submitForm() {
        let that = this;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            that.isBtnLoading = true;
            let data = Object.assign({}, that.ruleForm);
            xz.ArdCurStat(data, "AddDelUpTaxInforCollection").then((res) => {
              that.isBtnLoading = false;
              if (res.status == "ok") {
                that.$message.success(res.msg || "保存成功");
                that.dialogVisible = false;
                that.getList();
              } else {
                that.$message.error(res.msg || "保存失败");
              }
            });
          }
        });
      },
      // 导入弹窗
      importExcel() {
        this.importUrl = "";
        this.showImport = true;
      },
      // 下载导入模板
      downloadTemp() {
        let path = this.headPath + "excel/024dc6c2-99e3-41f6-b847-438a2d2795fd/E20260827130926847.xlsx";
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },
      handleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.importUrl = res && res.Url ? res.Url : res;
          } else {
            this.importUrl = "";
          }
        });
      },
      handleRemove() {
        this.importUrl = "";
      },
      // C117 导入（GET）
      confirmImport() {
        if (!this.importUrl) {
          this.$message.warning("请先选择Excel文件");
          return;
        }
        this.isBtnLoading = true;
        let url = encodeURIComponent(this.importUrl);
        xz.ArdCurStatGetFun("ExporTaxInforCollection", "?Url=" + url).then((res) => {
          this.isBtnLoading = false;
          if (res.status == "ok") {
            this.$message.success(res.msg || "导入成功");
            this.showImport = false;
            this.getList();
          } else {
            this.$message.error(res.msg || "导入失败");
          }
        });
      },
      // C120 导出（GET blob）
      exporList() {
        let that = this;
        let q = [];
        if (this.listQuery.Name) q.push("Name=" + encodeURIComponent(this.listQuery.Name));
        if (this.listQuery.CardId) q.push("CardId=" + encodeURIComponent(this.listQuery.CardId));
        if (this.listQuery.PhoneNum) q.push("PhoneNum=" + encodeURIComponent(this.listQuery.PhoneNum));
        if (this.listQuery.PayrollCompany) q.push("PayrollCompany=" + encodeURIComponent(this.listQuery.PayrollCompany));
        q.push("PageModel.Page=1");
        q.push("PageModel.Rows=10000");
        xz.ArdCurStatGetFun2("EGetTaxInforCollectionPageList", "?" + q.join("&")).then((res) => {
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "税务端信息采集列表.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
          } catch (e) {
            that.$message.error("导出异常");
          }
        });
      },
    },
  };
</script>

<style scoped>
  .page_taxInfoList {
    background: #f5f7fa;
    min-height: 100%;
  }

  .page_taxInfoList .r_dropDownScreen {
    padding-left: 29px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .page_taxInfoList .main-con {
    background: #fff;
    margin-top: 10px;
  }

  .re_down_form .el-form-item {
    margin-bottom: 0px;
    margin-right: 0;
  }
</style>
<style>
  .page_taxInfoList .declareForm .el-form-item {
    margin-bottom: 0px;
  }

  .page_taxInfoList .declareForm .el-form-item__error {
    top: 34px;
  }
</style>